'use client';

import { useEffect } from 'react';
import Link from 'next/link';
import { Button } from '@/components/ui/button';

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error(error);
  }, [error]);

  return (
    <div className="flex min-h-[100dvh] items-center justify-center bg-[var(--bg-base)] px-6 py-12">
      <div className="max-w-lg space-y-4 rounded-[var(--radius-lg)] border border-[var(--border-default)] bg-[var(--bg-surface)] p-8 text-[var(--text-primary)] shadow-[var(--shadow-dialog)]">
        <div className="space-y-2">
          <p className="text-sm font-semibold uppercase tracking-[0.18em] text-[var(--text-secondary)]">
            Application error
          </p>
          <h1 className="text-2xl font-extrabold leading-tight">Something went wrong</h1>
          <p className="text-sm text-[var(--text-secondary)]">
            We ran into an unexpected error. Use the options below to try again or start a new session.
          </p>
          <p className="text-xs text-[var(--text-secondary)]">
            Digest: <code className="font-mono text-xs text-[var(--text-primary)]">{error.digest ?? 'unavailable'}</code>
          </p>
        </div>

        <div className="flex flex-wrap gap-3">
          <Button type="button" onClick={reset}>
            Retry
          </Button>
          <form action="/auth/sign-out" method="post">
            <Button type="submit" variant="outline">
              Sign out
            </Button>
          </form>
          <Button variant="ghost" asChild>
            <Link href="/">Back to home</Link>
          </Button>
        </div>
      </div>
    </div>
  );
}
